const state = {
  corp_partner_list: [],
  corp_partner_list_id: [],
};

export default state;
